module.exports = __webpack_public_path__ + "static/media/location_circle.153027e3.svg";